module.exports = __webpack_public_path__ + "static/media/sumo.775000bb.png";